/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBCURRENCY = {
    Zar: 'ZAR'
} as const;
export type GHUBCURRENCY = typeof GHUBCURRENCY[keyof typeof GHUBCURRENCY];


export function GHUBCURRENCYFromJSON(json: any): GHUBCURRENCY {
    return GHUBCURRENCYFromJSONTyped(json, false);
}

export function GHUBCURRENCYFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBCURRENCY {
    return json as GHUBCURRENCY;
}

export function GHUBCURRENCYToJSON(value?: GHUBCURRENCY | null): any {
    return value as any;
}

